import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer px-5">
        <Container fluid={true}>
          <Row className="d-flex align-items-center">
            <Col md={6}>
              <h6 className="text-black">{new Date().getFullYear()} © Fans to 5K.</h6>
            </Col>
            <Col md={6}>
              <h6 className="text-black text-end">Design and Developed By Zithas Technologies</h6>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
